'use client';

import { BookDemoButton } from '@/components/ui';
import IndustryHero from '@/components/industry/IndustryHero';
import IndustryCommandCentre from '@/components/industry/IndustryCommandCentre';
import { useTranslation } from '@/hooks/useTranslation';

const BLUE = { color: 'var(--brand)' };
const DEEP = { color: 'var(--brand-deep)' };

/* Sector command-centre data — FMCG brand & product operations.
   Sample/mock dashboard content (not marketing copy). */
const CC = {
  pulseTitle: 'Brand & product pulse',
  kpis: [
    { val: '2,210', lbl: 'Live mentions', live: true },
    { val: '98', lbl: 'Open escalations' },
    { val: '2.9m', lbl: 'Avg. first response' },
  ],
  sentiment: [
    { lbl: 'Positive', pct: 41, tone: 'positive' },
    { lbl: 'Neutral', pct: 33, tone: 'neutral' },
    { lbl: 'Negative', pct: 26, tone: 'negative' },
  ],
  sla: { pct: 82, lbl: 'SLA met' },
  tickerLabel: 'Incoming complaints',
  tickerItems: [
    { letter: 'P', text: 'Found a defect in sealed pack', handle: '@pooja_r', tag: 'Quality', tagLevel: 'high' },
    { letter: 'A', text: 'Product out of stock everywhere', handle: '@arjun_k', tag: 'Supply', tagLevel: 'med' },
    { letter: 'S', text: 'Taste changed in new batch', handle: '@sneha_v', tag: 'Product', tagLevel: 'med' },
    { letter: 'R', text: 'Expired stock on the shelf', handle: '@rohit_m', tag: 'Compliance', tagLevel: 'high' },
  ],
  chips: [
    { variant: 'light', title: 'Quality signal', sub: 'Defect mentions trending up' },
    { variant: 'dark', title: 'AgentIQ routed', sub: 'Batch issue → QA in 2s' },
  ],
};

export default function FmcgHero() {
  const { t } = useTranslation();

  return (
    <IndustryHero
      layout="visual"
      breadcrumb={{
        ariaLabel: t('breadcrumb.breadcrumb'),
        label: t('footer.col.industries'),
        href: '/industries',
        current: t('FMCG'),
      }}
      title={
        <>
          {t('industries_fmcg.trust_earned_in_decades_lost_in_hou')}{' '}
          <span className="serif-accent italic">{t('industries_fmcg.fmcg_brand_reputation_management_pl')}</span>
          {' '}{t('industries_fmcg.built_for')}{' '}
          <span className="serif-accent italic">{t('industries_fmcg.indias_most_scrutinised_market')}</span>.
        </>
      }
      lead={
        <>
          {t('industries_fmcg.indias_fmcg_market_hit_211_billion_2')}{' '}
          <span style={BLUE}>{t('industries_fmcg.food_safety_post')}</span>{t('industries_fmcg.a_microinfluencers_ingredient_break')}{' '}
          <span style={DEEP}>{t('industries_retail_ecommerce.locobuzz_intercepts_all_three')}</span>
        </>
      }
      actions={<BookDemoButton label={t('industries_fmcg.book_your_30min_fmcg_brand_intellig')} />}
      visual={<IndustryCommandCentre ariaLabel="FMCG brand command centre" {...CC} />}
    />
  );
}
